import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import HuntGroups from "../components/topviews/HuntGroups";

function HuntGroup(props) {
  const { t, i18n } = useTranslation();
  const [pickedLanguage, setPickedLanguage] = useState("united-kingdom");
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={19}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header px-0">
                    <h5 className="fw-600">{t("huntGroups")}</h5>
                  </div>
                  <div className="card-body px-0">
                    <HuntGroups />
                  </div>
                </div>
              </section>
            </>
          }
        />
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}
export default HuntGroup;
